import './styles/Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons'

export default function Footer({setPage}) {
    return (
        <footer>
            <div className='footer-container'>
                <ul className='footer-list-main'>
                    <li>
                        <a href='https://www.linkedin.com/in/gordon-daole-wellman-0b275566/' target='_blank' rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} size='2x' />
                        </a>                        
                    </li>
                    <li>
                        <a href='https://www.instagram.com/almost_wound/' target='_blank' rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faInstagram} size='2x' />
                        </a>                       
                    </li>
                    <li>
                        <a href='https://github.com/wellgordon?tab=repositories' target='_blank' rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faGithub} size='2x' />
                        </a>
                    </li>                    
                </ul>
                <ul className='footer-list-sub'>
                    <li className='footer-sub-li'>
                        <a href='https://www.fontawesome.com' target='_blank' rel="noopener noreferrer">
                            Icons by @font-awesome
                        </a> 
                    </li>
                </ul>
            </div>
            
        </footer>
    )
}